import React from 'react';
import { Box } from '@mui/material';
import SectionLayout from '../../shared/layout/SectionLayout';
import { useCompanyData } from '../contexts/DataContext';
import { SectionTitle as T1SectionTitle, SectionSubtitle as T1SectionSubTitle } from '../../Template1/components/SectionTitle';
import { SectionTitle as T2SectionTitle, SectionSubtitle as T2SectionSubTitle } from '../../Template2/components/SectionTitle';
import { SectionTitle as T3SectionTitle, SectionSubtitle as T3SectionSubTitle } from '../../Template3/components/SectionTitle';
import { SectionTitle as T4SectionTitle, SectionSubtitle as T4SectionSubTitle } from '../../Template4/components/SectionTitle';
import '../../shared/styles.css';

const TitleList = {
    '1': T1SectionTitle,
    '2': T2SectionTitle,
    '3': T3SectionTitle,
    '4': T4SectionTitle,
};

const SubTitleList = {
    '1': T1SectionSubTitle,
    '2': T2SectionSubTitle,
    '3': T3SectionSubTitle,
    '4': T4SectionSubTitle,
};

function Map({ contentData  }) {
    const { data } = useCompanyData();
    const { isRTL, themeDesign } = data;
    const {  backgroundColor, backgroundImage, backgroundStyle, backgroundSize, width, height, title, arTitle, subTitle, arSubTitle, titleFormat, titleFontSize, subTitleFontSize, titleFontColor, subTitleFontColor, paddingTop, paddingBottom, embedUrl } = contentData || {};
  
    const _title = title ? (isRTL === 'ar' ? (arTitle ? arTitle : title) : title) : 'Our Location';
    const _subTitle = subTitle ? (isRTL === 'ar' ? (arSubTitle ? arSubTitle : subTitle) : subTitle) : 'Map';
  
    const TitleComponent = TitleList?.[themeDesign];
    const SubTitleComponent = SubTitleList?.[themeDesign];

    const ChildComponent = () => (
        <Box width="100%" m="auto" position="relative">
            <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
                <SubTitleComponent pFontSize={subTitleFontSize} color={subTitleFontColor}>{_subTitle}</SubTitleComponent>
                <TitleComponent pFontSize={titleFontSize} color={titleFontColor} variant={titleFormat}>{_title}</TitleComponent>
            </Box>
            <Box pb={3} display="flex" 
            >
                <iframe
                    width={width ? `${width}px` : '100%'}
                    height={height ? `${height}px` : '690px'}
                    style={{border:"none",margin:'auto'}}
                    loading="lazy"
                    allowfullscreen
                    referrerpolicy="no-referrer-when-downgrade"
                    src={embedUrl}>
                </iframe>
            </Box>
        </Box>
    )

    return (
    <Box
        style={{
        width:'100%',
        ...(backgroundStyle === 'image' && backgroundImage ?
            {
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundRepeat: 'no-repeat',
            }
            :
            backgroundStyle === 'gradient' ? 
            {backgroundImage: backgroundColor} 
            : {backgroundColor: backgroundColor || 'transparent'}
        )
        }}
    >
        {backgroundSize === 'fullWidth' ? 
            <Box 
                style={{width:'100%',paddingTop:`${paddingTop !== undefined ? paddingTop : '64'}px`,paddingBottom:`${paddingBottom !== undefined ? paddingBottom : '64'}px`}}>
                {ChildComponent()}
            </Box>
        :
            <SectionLayout paddingTop={paddingTop} paddingBottom={paddingBottom}>
                {ChildComponent()}
            </SectionLayout>
        }
    </Box>
    );
};

export default Map;